import React from 'react';

type LoadingStateProps = {
  message?: string;
  className?: string;
};

const LoadingState: React.FC<LoadingStateProps> = ({ message = 'Loading...', className }) => {
  const classes = className ? `text-sm fg-muted ${className}` : 'text-sm fg-muted';
  return <div className={classes}>{message}</div>;
};

export default LoadingState;
